var map = {
	"./Maestro.svg": 1047,
	"./PayPal.svg": 8121,
	"./americanexpress.svg": 698,
	"./amusement.svg": 3951,
	"./apple_pay.svg": 1723,
	"./bathroom.svg": 7443,
	"./bed.svg": 9771,
	"./blocks.svg": 7329,
	"./bmb.svg": 5642,
	"./bmb_full.svg": 9379,
	"./bullseye.svg": 7327,
	"./bus.svg": 3028,
	"./calendar.svg": 2313,
	"./camera.svg": 9012,
	"./chart.svg": 7918,
	"./chevron-down.svg": 1410,
	"./circle-exclamation.svg": 7350,
	"./city.svg": 7162,
	"./cleaning.svg": 2829,
	"./clock.svg": 8477,
	"./comments.svg": 4281,
	"./cookie.svg": 8173,
	"./country.svg": 9900,
	"./crown.svg": 5603,
	"./day.svg": 4265,
	"./envelope.svg": 7204,
	"./event.svg": 1221,
	"./eye.svg": 6536,
	"./facebook.svg": 1162,
	"./food.svg": 5121,
	"./google_pay.svg": 7565,
	"./health.svg": 3650,
	"./hide.svg": 9620,
	"./house.svg": 1190,
	"./ideal.svg": 3345,
	"./info.svg": 3246,
	"./instagram.svg": 1855,
	"./institute.svg": 9846,
	"./jobs.svg": 7807,
	"./layers.svg": 6556,
	"./lighthouse.svg": 4566,
	"./list.svg": 7830,
	"./location.svg": 7330,
	"./logout.svg": 8766,
	"./marker.svg": 5981,
	"./mastercard.svg": 898,
	"./money.svg": 2037,
	"./mug.svg": 6384,
	"./news.svg": 3793,
	"./parking.svg": 3499,
	"./people.svg": 2244,
	"./photo-film.svg": 5554,
	"./plane-arrive.svg": 3870,
	"./plane-departure.svg": 5017,
	"./platform:/amusement.svg": 2375,
	"./platform:/bathroom.svg": 4656,
	"./platform:/bed.svg": 1615,
	"./platform:/blocks.svg": 2398,
	"./platform:/bus.svg": 4752,
	"./platform:/calendar.svg": 7713,
	"./platform:/camera.svg": 9503,
	"./platform:/city.svg": 9974,
	"./platform:/cookie.svg": 1654,
	"./platform:/country.svg": 3411,
	"./platform:/facebook.svg": 4554,
	"./platform:/food.svg": 5698,
	"./platform:/health.svg": 7146,
	"./platform:/hide.svg": 8386,
	"./platform:/info.svg": 3608,
	"./platform:/instagram.svg": 3102,
	"./platform:/institute.svg": 3701,
	"./platform:/location.svg": 8302,
	"./platform:/marker.svg": 5821,
	"./platform:/parking.svg": 1545,
	"./platform:/people.svg": 6671,
	"./platform:/propTypes/Apartment.svg": 2180,
	"./platform:/propTypes/Boat.svg": 9329,
	"./platform:/propTypes/Home.svg": 9987,
	"./platform:/propTypes/House.svg": 8763,
	"./platform:/propTypes/Villa.svg": 6278,
	"./platform:/sad.svg": 4268,
	"./platform:/search-solid.svg": 7998,
	"./platform:/settings.svg": 521,
	"./platform:/share.svg": 6264,
	"./platform:/shopping.svg": 7625,
	"./platform:/show.svg": 5464,
	"./platform:/sport.svg": 6253,
	"./platform:/state.svg": 3267,
	"./platform:/tree.svg": 6930,
	"./platform:/twitter.svg": 1375,
	"./platform:/wheelchair.svg": 8308,
	"./platform:/x.svg": 6408,
	"./propTypes/Apartment.svg": 7144,
	"./propTypes/Boat.svg": 8391,
	"./propTypes/Car rental.svg": 8101,
	"./propTypes/Home.svg": 5714,
	"./propTypes/House.svg": 1898,
	"./propTypes/Villa.svg": 7478,
	"./sad.svg": 3474,
	"./scape.svg": 2132,
	"./search-solid.svg": 2319,
	"./settings.svg": 6182,
	"./share.svg": 2059,
	"./shopping.svg": 9643,
	"./show.svg": 9670,
	"./sport.svg": 6498,
	"./state.svg": 6884,
	"./trash.svg": 5411,
	"./tree.svg": 829,
	"./tv.svg": 4003,
	"./twitter.svg": 6842,
	"./users.svg": 6823,
	"./visa2.svg": 8229,
	"./wheelchair.svg": 9914,
	"./wifi.svg": 4782,
	"./x.svg": 2800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 619;